module.exports = __webpack_public_path__ + "img/zest.2250e1e9.svg";